import * as prismicCustomTypesClient from "@prismicio/custom-types-client";
import fetch from './../../_node_modules/node-fetch/src/index.js';
import * as z from "zod";
import { API_ENDPOINTS } from "../../constants/API_ENDPOINTS.js";
import { PRISMIC_CLI_USER_AGENT } from "../../constants/PRISMIC_CLI_USER_AGENT.js";
import { assertPluginsInitialized } from "../../lib/assertPluginsInitialized.js";
import { decodeHookResult } from "../../lib/decodeHookResult.js";
import { CustomTypeSchema } from "../../lib/typesInternalSchemas.js";
import { BaseManager } from "../BaseManager.js";
class CustomTypesManager extends BaseManager {
  async readCustomTypeLibrary() {
    assertPluginsInitialized(this.pluginSystemRunner);
    const hookResult = await this.pluginSystemRunner.callHook("custom-type-library:read", void 0);
    const { data, errors } = decodeHookResult(z.object({
      ids: z.array(z.string())
    }), hookResult);
    return {
      ids: data[0]?.ids || [],
      errors
    };
  }
  async readAllCustomTypes(args) {
    assertPluginsInitialized(this.pluginSystemRunner);
    const res = {
      models: [],
      errors: []
    };
    const { ids, errors } = await this.readCustomTypeLibrary();
    res.errors = [...res.errors, ...errors];
    if (ids) {
      for (const id of ids) {
        const { model, errors: errors2 } = await this.readCustomType({ id });
        res.errors = [...res.errors, ...errors2];
        if (model && (!args || args.format === model.format)) {
          res.models.push({ model });
        }
      }
    }
    return res;
  }
  async createCustomType(args) {
    assertPluginsInitialized(this.pluginSystemRunner);
    const hookResult = await this.pluginSystemRunner.callHook("custom-type:create", args);
    return {
      errors: hookResult.errors
    };
  }
  async readCustomType(args) {
    assertPluginsInitialized(this.pluginSystemRunner);
    const hookResult = await this.pluginSystemRunner.callHook("custom-type:read", args);
    const { data, errors } = decodeHookResult(z.object({
      model: CustomTypeSchema
    }), hookResult);
    return {
      model: data[0]?.model,
      errors
    };
  }
  async updateCustomType(args) {
    assertPluginsInitialized(this.pluginSystemRunner);
    const { model } = args;
    const customTypeUpdateResult = await this.pluginSystemRunner.callHook("custom-type:update", { model });
    if (customTypeUpdateResult.errors.length > 0) {
      return { errors: customTypeUpdateResult.errors };
    }
    return { errors: [] };
  }
  async renameCustomType(args) {
    assertPluginsInitialized(this.pluginSystemRunner);
    const hookResult = await this.pluginSystemRunner.callHook("custom-type:rename", args);
    return {
      errors: hookResult.errors
    };
  }
  async deleteCustomType(args) {
    assertPluginsInitialized(this.pluginSystemRunner);
    const { model, errors: readCustomTypeErrors } = await this.readCustomType({
      id: args.id
    });
    if (model) {
      const hookResult = await this.pluginSystemRunner.callHook("custom-type:delete", { model });
      return {
        errors: hookResult.errors
      };
    } else {
      return {
        errors: readCustomTypeErrors
      };
    }
  }
  async fetchRemoteCustomTypes() {
    const authenticationToken = await this.user.getAuthenticationToken();
    const repositoryName = await this.project.getRepositoryName();
    const client = prismicCustomTypesClient.createClient({
      endpoint: API_ENDPOINTS.PrismicLegacyCustomTypesApi,
      repositoryName,
      token: authenticationToken,
      fetch,
      fetchOptions: {
        headers: {
          "User-Agent": PRISMIC_CLI_USER_AGENT
        }
      }
    });
    return await client.getAllCustomTypes();
  }
}
export {
  CustomTypesManager
};
//# sourceMappingURL=CustomTypesManager.js.map
